import {
  ALERT_ORGANIZATION_SCOPE_LABEL,
  type AlertSecurityGroup,
} from '@kirin/api-client/contracts/alerts';

/**
 * Label for a user who belongs to no security group (KIR-3800).
 *
 * Re-exported from the shared contract rather than redefined here: the same
 * string is the alerts filter option, the ORDER BY collation key on the server,
 * and the chip in the cell, so it must not be able to drift between them.
 *
 * The groups themselves are supplied by the API (`GroupedAlert.securityGroups`
 * and `AlertOccurrence.securityGroup`) — the same fields the server sorts and
 * filters on — so this module holds presentation only, no derivation.
 */
export const ORGANIZATION_SCOPE_LABEL = ALERT_ORGANIZATION_SCOPE_LABEL;

/**
 * Display label for a group referenced by an alert.
 *
 * Deleted groups are suffixed, matching how the alerts Security Group filter
 * labels its options. This is not cosmetic: the soft delete frees the name (the
 * unique index only covers live rows), so a deleted "Engineering" and a new
 * "Engineering" can both be attributed to alerts at the same time. Unlabelled
 * they are indistinguishable on screen.
 */
export function securityGroupLabel(group: AlertSecurityGroup): string {
  return group.deleted ? `${group.name} (deleted)` : group.name;
}
